import { currency } from "./price";
const dayjs = require("dayjs").default;
import relativeTime from "dayjs/plugin/relativeTime";
import utcFormat from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
import tz from "dayjs/plugin/timezone";

dayjs.extend(relativeTime);
dayjs.extend(utcFormat);
dayjs.extend(tz);
dayjs.extend(customParseFormat);

export function formatUTCTime(date, format = "HH:mm DD/MM/YYYY") {
  const data = new Date(`${date}Z`);
  return dayjs(data).tz('Asia/Ho_Chi_Minh').format(format);
}

export function calculatorBetweenTime(date) {
  const durations = dayjs(date).fromNow(true);
  return durations;
}

/**
 * 10000 => "10.000"
 */
export function toThousandFilter(num, decimal = 2) {
  let value = +num || 0;
  const [integerPart, fractionalPart] = value.toFixed(decimal).split(".");
  const formatInteger = integerPart
    .toString()
    .replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, "."));
  if (fractionalPart) return `${formatInteger},${fractionalPart}`;
  return formatInteger;
}

/**
 * Upper case first char
 */
export function uppercaseFirst(string) {
  return string?.charAt(0)?.toUpperCase() + string?.toLowerCase()?.slice(1);
}

/**
 * Format datetime from timestamp
 */
export function formatDateTime(datetime, format = "HH:mm DD/MM/YYYY") {
  return dayjs(datetime).format(format);
}
export function formatDateTimeUTC(datetime, format = "HH:mm DD/MM/YYYY") {
  return dayjs.utc(datetime).format(format);
}
export function formatDateTimeCustom(
  datetime,
  format = "HH:mm DD/MM/YYYY",
  currentFormat = "D/M/YYYY"
) {
  return dayjs(datetime, currentFormat).format(format);
}

export function now() {
  return Date.now();
}

export function formatToVNDate(datetime) {
  return dayjs(datetime).format("DD/MM/YYYY");
}

/**
 * Convert bytes to other Size
 */
export function bytesToSize(byte, fixed) {
  const specified = fixed || 2;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  if (!byte || byte <= 1) return "0 B";
  const i = Number(Math.floor(Math.log(byte) / Math.log(1024)), 10);
  if (i === 0) return `${byte} ${sizes[i]}`;
  return `${parseFloat((byte / 1024 ** i).toFixed(specified))} ${sizes[i]}`;
}

export function parseFlavorServer(flavor) {
  if (!flavor) return "";
  const byte = 1024;
  return `${flavor?.vcpus} CPU / ${flavor?.ram / byte} GB`;
}

export function serverIcon(value) {
  let iconName = "cloud-server-fill";
  if (value) {
    iconName = value.split(/-| /)[0];
    const iconOs = {
      suse: "suse",
      mysql: "my-sql",
      postgresql: "postgre-sql",
      openvpn: "open-vpn",
      iis: "iis-mssql",
      owncloud: "own-cloud",
      nextcloud: "next-cloud",
      cwp: "cwp7",
      nodejs: "node",
      clearos: "clear-os",
    };
    Object.keys(iconOs).forEach((name) => {
      if (value.toLowerCase().startsWith(name)) {
        iconName = iconOs[name];
      }
    });
  }
  return iconName.toLowerCase();
}

export function formatOsName(name) {
  return name?.split(/[ .:;?!~,`'"+@!#$%^&*|()<>{}[\]\r\n/\\]+/)?.[0];
}

export function formatPrice(value, bandwidth = false) {
  if (value === 0) {
    return bandwidth ? "0 đ" : "--";
  }

  if (value >= 1000000) {
    return parseFloat(value / 1000000).toFixed(2) + " tr";
  }

  return `${currency(value)} đ`;
}

export function docsUrlToPathTag(url, includeStr = "") {
  try {
    const nextUrl = new URL(url);
    return url.includes(includeStr) ? `#${nextUrl.pathname}` : url;
  } catch (error) {
    return url;
  }
}

export function quotaSize(size = 0, ram = false) {
  let sizeGb = size;
  if (ram) {
    sizeGb = size / 1024;
  }
  if (sizeGb > 1000) {
    return `${(sizeGb / 1000)?.toFixed(1)} TB`;
  }
  return `${sizeGb?.toFixed(1)} GB`;
}
